import type { InferOutput } from 'valibot'
import { object, optional } from 'valibot'
import { SolrParamsKey } from '~~/shared/solr'
import { newestDocResponseSchema } from '~/utils/solr/newest'
import { newestDocsParamsSchema } from '~/utils/solr/params'

export const solrNewestDocsParamsSchema = object({
  [SolrParamsKey.Newest]: optional(newestDocsParamsSchema),
})

export type SolrNewestDocsParams = InferOutput<typeof solrNewestDocsParamsSchema>

export function useNewestDocsQuery(params?: MaybeRef<SolrNewestDocsParams>) {
  const options = useSolrQueryOptions({
    endpoint: 'newest',
    params,
    schema: newestDocResponseSchema,
  })

  return useQuery(options)
}
